/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export class ScreenTaskControllerTypes {
    public static readonly AUDIO_TRACK_OVERLAY = 'AUDIO_TRACK_OVERLAY';

    public static readonly CANCEL_ONE_PASS_OVERLAY_TASKS = 'CANCEL_ONE_PASS_OVERLAY_TASKS';

    public static readonly CANCEL_RECORDING_OVERLAY_TASKS = 'CANCEL_RECORDING_OVERLAY_TASKS';

    public static readonly CHANNEL_OPTIONS_OVERLAY = 'CHANNEL_OPTIONS_OVERLAY';

    public static readonly CREATE_ONE_PASS_OVERLAY_TASKS = 'CREATE_ONE_PASS_OVERLAY_TASKS';

    public static readonly DEFAULT_ACCOUNT_TASKS = 'DEFAULT_ACCOUNT_TASKS';

    public static readonly DEFAULT_ANTIBURN_OSD_TASKS = 'DEFAULT_ANTIBURN_OSD_TASKS';

    public static readonly DELETE_OVERLAY_TASKS = 'DELETE_OVERLAY_TASKS';

    public static readonly DEFAULT_COLLECTION_SCREEN_TASKS = 'DEFAULT_COLLECTION_SCREEN_TASKS';

    public static readonly DEFAULT_ERROR_TASKS = 'DEFAULT_ERROR_TASKS';

    public static readonly DEFAULT_GUIDE_TASKS = 'DEFAULT_GUIDE_TASKS';

    public static readonly DEFAULT_MAIN_SETTING_TASKS = 'DEFAULT_MAIN_SETTING_TASKS';

    public static readonly DEFAULT_MY_SHOWS_TASKS = 'DEFAULT_MY_SHOWS_TASKS';

    public static readonly LOADING_STATE_TASK = 'LOADING_STATE_TASK';

    public static readonly DEFAULT_PROGRAM_SCREEN_TASKS = 'DEFAULT_PROGRAM_SCREEN_TASKS';

    public static readonly DEFAULT_SETTING_TASKS = 'DEFAULT_SETTING_TASKS';

    public static readonly DEFAULT_SIDEBAR_NAVIGATION_MENU_TASKS =
        'DEFAULT_SIDEBAR_NAVIGATION_MENU_TASKS';

    public static readonly DEFAULT_SIGN_IN_TASKS = 'DEFAULT_SIGN_IN_TASKS';

    public static readonly DEFAULT_SPLASH_SCREEN_TASKS = 'DEFAULT_SPLASH_SCREEN_TASKS';

    public static readonly DEFAULT_VIDEO_PLAYER_TASKS = 'DEFAULT_VIDEO_PLAYER_TASKS';

    public static readonly DELETE_RECORDING_OVERLAY_TASKS = 'DELETE_RECORDING_OVERLAY_TASKS';

    public static readonly ENTER_CHANNEL_NUMBER = 'ENTER_CHANNEL_NUMBER';

    public static readonly EXIT_CONFIRMATION_OVERLAY = 'EXIT_CONFIRMATION_OVERLAY';

    public static readonly FULL_INFO = 'FULL_INFO';

    public static readonly GO_TO_OVERLAY_TASKS = 'GO_TO_OVERLAY_TASKS';

    public static readonly GUIDE_INTERACTIVE_LAYER_TASKS = 'GUIDE_INTERACTIVE_LAYER_TASKS';

    public static readonly GUIDE_SPINNER_TASKS = 'GUIDE_SPINNER_TASKS';

    public static readonly KEEP_UNTIL_RECORDING_OVERLAY = 'KEEP_UNTIL_RECORDING_OVERLAY';

    public static readonly LANGUAGE_NOT_SUPPORTED_OVERLAY = 'LANGUAGE_NOT_SUPPORTED_OVERLAY';

    public static readonly LIVE_TV_INTERACTIVE_LAYER_TASKS = 'LIVE_TV_INTERACTIVE_LAYER_TASKS';

    public static readonly LP_CODE_EXPIRED_SIGNIN_TASK = 'LP_CODE_EXPIRED_SIGNIN_TASK';

    public static readonly MODIFY_ONE_PASS_OVERLAY_TASKS = 'MODIFY_ONE_PASS_OVERLAY_TASKS';

    public static readonly MULTI_CANCEL_ONE_PASS_OVERLAY_TASKS =
        'MULTI_CANCEL_ONE_PASS_OVERLAY_TASKS';

    public static readonly NO_NETWORK_OVERLAY = 'NO_NETWORK_OVERLAY';

    public static readonly NO_TASK: 'NO_TASK';

    public static readonly ONE_LINE_GUIDE_TASKS = 'ONE_LINE_GUIDE_TASKS';

    public static readonly ONE_PASS_OPTIONS_OVERLAY_TASK = 'ONE_PASS_OPTIONS_OVERLAY_TASK';

    public static readonly ONEPASS_MANAGER_DEFAULT_TASKS = 'ONEPASS_MANAGER_DEFAULT_TASKS';

    public static readonly PC_CANNOT_COMPLETE_REQUEST_OVERLAY_TASK =
        'PC_CANNOT_COMPLETE_REQUEST_OVERLAY_TASK';

    public static readonly PC_DEFAULT_TASKS = 'PC_DEFAULT_TASKS';

    public static readonly PC_PIN_OVERLAY_TASK = 'PC_PIN_OVERLAY_TASK';

    public static readonly PC_SET_RATING_LIMITS_DEFAULT_TASKS =
        'PC_SET_RATING_LIMITS_DEFAULT_TASKS';

    public static readonly PC_TEMPORARY_PROBLEM_OVERLAY_TASK = 'PC_TEMPORARY_PROBLEM_OVERLAY_TASK';

    public static readonly PLAYER_ERROR_OVERLAY = 'PLAYER_ERROR_OVERLAY';

    public static readonly PREPARING_DATA = 'PREPARING_DATA';

    public static readonly PREPARING_VOD_RESUME_START_OVER_OVERLAY_TASKS =
        'PREPARING_VOD_RESUME_START_OVER_OVERLAY_TASKS';

    public static readonly RECORD_OVERLAY_TASKS = 'RECORD_OVERLAY_TASKS';

    public static readonly RECORDING_OVERLAY_TASKS = 'RECORDING_OVERLAY_TASKS';

    public static readonly SETTINGS_ACCOUNT_TASKS = 'SETTINGS_ACCOUNT_TASKS';

    public static readonly SETTINGS_INTERACTIVE_LAYER_TASKS = 'SETTINGS_INTERACTIVE_LAYER_TASKS';

    public static readonly SETTINGS_MENU_LANGUAGE_TASKS = 'SETTINGS_MENU_LANGUAGE_TASKS';

    public static readonly SETTINGS_PC_HIDE_ADULT_CONTENT_DEFAULT_TASKS =
        'SETTINGS_PC_HIDE_ADULT_CONTENT_DEFAULT_TASKS';

    public static readonly SETTINGS_RESET_APP_OVERLAY_TASKS = 'SETTINGS_RESET_APP_OVERLAY_TASKS';

    public static readonly SETTINGS_SIGN_OUT_ERROR_OVERLAY_TASKS =
        'SETTINGS_SIGN_OUT_ERROR_OVERLAY_TASKS';

    public static readonly SETTINGS_SIGN_OUT_OVERLAY_TASKS = 'SETTINGS_SIGN_OUT_OVERLAY_TASKS';

    public static readonly SETTINGS_USER_PREFERENCE_TASKS = 'SETTINGS_USER_PREFERENCE_TASKS';

    public static readonly SETTINGS_VIDEO_WINDOW_TASKS = 'SETTINGS_VIDEO_WINDOW_TASKS';

    public static readonly SIGN_IN_ERROR_OVERLAY_TASKS = 'SIGN_IN_ERROR_OVERLAY_TASKS';

    public static readonly SLO_TASKS = 'SLO_TASKS';

    public static readonly SOCU_ERROR_OVERLAY_TASKS = 'SOCU_ERROR_OVERLAY_TASKS';

    public static readonly SOS_ERROR_TASKS = 'SOS_ERROR_TASKS';

    public static readonly STANDARD_INFO = 'STANDARD_INFO';

    public static readonly STILL_THERE_OSD_TASKS = 'STILL_THERE_OSD_TASKS';

    public static readonly STOP_RECORDING_OVERLAY_TASKS = 'STOP_RECORDING_OVERLAY_TASKS';

    public static readonly STREAMING_OPTIONS_OVERLAY = 'STREAMING_OPTIONS_OVERLAY';

    public static readonly SUBTITLE_AND_CC_LANGUAGE_OVERLAY = 'SUBTITLE_AND_CC_LANGUAGE_OVERLAY';

    public static readonly TEMPORARY_GUIDE_ISSUE_OVERLAY = 'TEMPORARY_GUIDE_ISSUE_OVERLAY';

    public static readonly TEMPORARY_SERVICE_CONNECTION_ISSUE_OVERLAY =
        'TEMPORARY_SERVICE_CONNECTION_ISSUE_OVERLAY';

    public static readonly TRICKPLAY_MENU = 'TRICKPLAY_MENU';

    public static readonly TURBO_SCROLL = 'TURBO_SCROLL';

    public static readonly USER_PREF_INTERACTIVE_LAYER_TASKS = 'USER_PREF_INTERACTIVE_LAYER_TASKS';

    public static readonly USER_PREF_VIDEO_WINDOW_TASKS = 'USER_PREF_VIDEO_WINDOW_TASKS';

    public static readonly VOD_RESUME_START_OVER_OVERLAY_TASKS =
        'VOD_RESUME_START_OVER_OVERLAY_TASKS';
}
